





































import { Component, Watch } from 'vue-property-decorator';
import Alert from '@/components/Shared/Alert.vue';
import PageNames from '@/router/PageNames';
import SaascadaVue from '@/components/Shared/SaascadaVue';
import Organisation from '@/models/Customers/Organisations/Organisation';
import { OrganisationModule } from '@/store/Customers/OrganisationModule';
import { Debounce } from 'vue-debounce-decorator';

@Component({ name: 'Organisations', components: { Alert }, metaInfo: { title: 'Organisations' } })
export default class extends SaascadaVue {

    headers = [
        { text: this.$t('pageText.organisations.fields.name'), sortable: false, width: '40%'},
        { text: this.$t('pageText.organisations.fields.registrationCountry'), sortable: false, width: '20%' },
        { text: this.$t('pageText.organisations.fields.registrationNumber'), sortable: false, width: '20%' },
        { text: this.$t('pageText.organisations.fields.updatedAt'), sortable: false, width: '20%' }
    ];
    organisationsPage = 1;

    async created() {
        // Check for page number in URL parameters
        const page = this.$route.query.page;
        if (page) {
            this.organisationsPage = +page;
        }
    }

    async beforeMount() {
        await OrganisationModule.getOrganisations(this.organisationsPage);
    }

    get organisations() {
        return OrganisationModule.organisations;
    }

    get totalOrganisationsPages() {
        return OrganisationModule.totalOrganisationsPages;
    }

    get search() {
        return OrganisationModule.organisationsSearch;
    }

    set search(searchText: string) {
        OrganisationModule.updateOrganisationsSearch(searchText);
    }

    get loading() {
        return OrganisationModule.loading;
    }

    get pageSize() {
        return OrganisationModule.pageSize;
    }

    @Watch('organisationsPage')
    async onOrganisationsPageChanged() {
        // Update current page route with page number
        this.$router.push({ name: this.$route.name, query: { page: `${this.organisationsPage}` } });
        // Get new organisations
        await OrganisationModule.getOrganisations(this.organisationsPage);
    }

    // Wait before auto-searching to allow the user to type more
    @Debounce(500)
    @Watch("search", { immediate: false, deep: true })
    async searchChanged() {
        // Note that when the search changes it puts the user back to the first page, incase there are new organisations
        this.organisationsPage = 1;
        await OrganisationModule.getOrganisations(1);
    }

    async navigateToOrganisation(organisation: Organisation) {
        this.$router.push({ name: PageNames.Organisation, params: { id: organisation.id }, query: { tab: "0" } });
    }

}
